import { TripTypeOptions } from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { BookWidgetState } from '../../models/states/book-widget-state.interfaces';

export const updateBookWidgetTripTypeFn = (
  state: BookWidgetState,
  selectedTripType: TripTypeOptions
) => {
  const options = [...state.fields.tripTypesField.dropdownOptions];
  const dropdownOptions = options.map((dropdownOption) => {
    if (dropdownOption.value === selectedTripType) {
      return { ...dropdownOption, selected: true };
    } else {
      return { ...dropdownOption, selected: false };
    }
  });
  return {
    ...state.fields.tripTypesField,
    selectedTripType,
    dropdownOptions
  };
};
